import { Injectable, inject } from '@angular/core';

import { OddsFormatSettings } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

@Injectable({
    providedIn: 'root',
})
export class UserOddsFormatSettingsService {
    private readonly oddsFormatSettings = inject(OddsFormatSettings);

    get oddsFormat(): OddsDisplayFormat {
        return this.oddsFormatSettings.generalOddsFormat;
    }
}
